import React, { useEffect, useState, useRef } from 'react'
import { observer } from 'mobx-react';
import { useStore } from '../../../stores';
import ViewProfessionalPage from './viewProfessional';
import {SearchBar} from '../../../components';
import './style.scss';
import { 
    TextInput, 
    TextInputDropdown, 
    OutlinedButton, 
    ProfessionalCard, 
    PaginationControls 
} from '../../../components';
import { MenuItem } from '@mui/material';
import { useServerFilterUsers } from '../../../hooks/useUserFilter';
const SearchIcon = `${process.env.REACT_APP_CDN_URL}/globalAssets/SearchIcon.svg`;
const Credipple = `${process.env.REACT_APP_CDN_URL}/globalAssets/CredippleLogo.svg`;
const AddIcon = `${process.env.REACT_APP_CDN_URL}/globalAssets/AddIcon.svg`;
var mobile = require('is-mobile');

const EmailRegex = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;

const Professionals = observer(() => {
    const { authStore, userStore, uiStore } = useStore();
    const [, updateState] = useState();
    const forceUpdate = React.useCallback(() => updateState({}), []);
    const [Professionals, setProfessionals] = useState([]);
    const [Leads, setLeads] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [AddPro, setAddPro] = useState(false);
    const [ViewProfessional, setViewProfessional] = useState(false);
    const [SelectedUser, setSelectedUser] = useState({});
    const [Page, setPage] = useState(0);
    const [FullName, setFullName] = useState('');
    const [IsEdited, setisEdited] = useState(false);
    const [IsMenuOpen, setIsMenuOpen] = useState(false);
    const [NewUser, setNewUser] = useState({
        roles: [1988],
        accountType: "public",
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        address: "",
        city: "",
        state: "",
        country: "",
        bio: "",
        imgUrl: "",
        website: "",
        linkedin: "",
        instagram: "",
        twitter: "",
        facebook: "",
        companyName: null,
        companyRegistrationNumber: null,
        companyVatNumber: null,
        companyRole: null,
        businessType: null,
        companyWebsite: null,
        companyAddress: "",
        companyCity: "",
        companyState: "",
        companyCountry: "",
        companyIndustry: "",
        industry: "",
        positionInCompany: "",
        servicesAs: "",
        experienceLevel: '',
        vatNumber: "",
        accountUsage: "",
        notifications: [],
        professional: {
            gender: 'Prefer Not To Say',
            languages: '',
            ratePerDay: '',
            ratePerHour: '',
            services: ''
        },
        password: "",
        verified: false,
        blocked: false,
        webauthn: "",
        Authenticators: []
    });
    const [Pagination, setPagination] = useState({ 
        currentPage :  1, 
        hasMore     : false, 
        nextCursor  : "", 
        prevCursor  : "",
        pageSize    : 8, 
        totalPages  : 0, 
        totalUsers  : 0
    });
    const {serverFilterUsers} = useServerFilterUsers({userStore, uiStore, setUsers:setProfessionals, setPagination, searchTerm , i:'', type:'PROF'}) 
    const isFirstRender = useRef(true);
    useEffect(() => {
        fetchData("", 'PROF', '', searchTerm);
    }, [IsEdited]);
    useEffect(()=>{
        if (isFirstRender.current) {
            isFirstRender.current = false; 
            return; 
        }else{
            if (searchTerm !== "") {
                //( searchStr, lastId, navId, type)
                serverFilterUsers(searchTerm, "", "", "PROF");
            }else{
                fetchData("", "PROF", "", searchTerm);
            };
        };
    }, [searchTerm]);
    const fetchData = async (lastId, type, navId, searchTerm) => {
        uiStore.setLoading(true);
        try {
            let Users = await userStore.getUsers(lastId, type, navId, searchTerm);

            if (!Users || !Array.isArray(Users.users)) {
                uiStore.showNotification('Failed to fetch users.', 'error');
                setProfessionals([]);
                return;
            }

            setProfessionals(Users.users || []);
            setPagination(Users.pagination || {
                currentPage :  1,
                hasMore     : false,
                nextCursor  : "",
                prevCursor  : "",
                pageSize    : 8,
                totalPages  : 0,
                totalUsers  : 0
            });
            forceUpdate();
        } catch (error) {
            uiStore.showNotification(`Error fetching users: ${error.message || error}`, 'error');
        } finally {
            uiStore.setLoading(false);
        }
    };

    const handleOpenAddProfessional = () => {
        setAddPro(true);
        forceUpdate();
    };

    const handleSearchChange = (value) => {
        setSearchTerm(value);
    };

    const filteredPros = Professionals.filter(pro => {
        if (!searchTerm) return true;
        const searchValue = String(searchTerm).toLowerCase();
        return (
            String(`${pro.firstName} ${pro.lastName}`).toLowerCase().includes(searchValue) || 
            (pro.email && pro.email.toLowerCase().includes(searchValue))
        );
    });

    const handleViewUser = (id) => {
        let pros = [...Professionals];
        let selectedPro = pros.find(pro => pro._id === id);
        setSelectedUser(selectedPro);
        setViewProfessional(true);
    };

    const handleUserDetailChange = (e) => {
        let user = { ...NewUser };

        if (e.currentTarget.id === 'Name') {
            let fullName = e.target.value;
            user.firstName = fullName.split(' ')[0] || "";
            user.lastName = fullName.split(' ')[1] || "";
            setFullName(fullName);
        }
        if (e.currentTarget.id === 'ContactNumber') {
            const value = e.target.value;
            if (/[^0-9]/.test(value)) return;
            user.phone = value;
        }
        if (e.currentTarget.id === 'Email') user.email = e.target.value;
        if (e.currentTarget.id === 'lang') user.professional.languages = e.target.value;
        if (e.currentTarget.id === 'dailyRate') user.professional.ratePerDay = e.target.value;
        if (e.currentTarget.id === 'location') user.location = e.target.value;
        if (e.currentTarget.id === 'industry') user.industry = e.target.value;

        setNewUser(user);
        forceUpdate();
    };

    const handleSaveUser = async () => {
        uiStore.setLoading(true);
        try {
            let user = NewUser;
            let regexPass = EmailRegex.test(user.email);
            if (!regexPass) {
                uiStore.showNotification('Invalid email address.', 'error');
                uiStore.setLoading(false);
                return;
            }
            let result = await userStore.createUser(user);
            if (!result) {
                uiStore.showNotification('Error saving user.', 'error');
                return;
            }
            uiStore.showNotification('User saved successfully.', 'success');

            // Refresh the list in background
            fetchData("", 'PROF', '');

            // ✅ Keep Add form open (do not setAddPro(false))
            // Optional: reset form fields for quick add
            setNewUser({
                ...NewUser,
                firstName: "",
                lastName: "",
                email: "",
                phone: "",
                professional: { gender: 'Prefer Not To Say', languages: '', ratePerDay: '', ratePerHour: '', services: '' }
            });
            setFullName("");
        } catch (e) {
            uiStore.showNotification(`Error saving user: ${e.message || e}`, 'error');
        } finally {
            uiStore.setLoading(false);
        }
    };

    const handleRoleChange = (e) => {
        setNewUser({ ...NewUser, professional: { ...NewUser.professional, services: e.target.value } });
        forceUpdate();
    };

    const handleGenderChange = (e) => {
        setNewUser({ ...NewUser, professional: { ...NewUser.professional, gender: e.target.value } });
        forceUpdate();
    };

    const handleEXPChange = (e) => {
        setNewUser({ ...NewUser, experienceLevel: e.target.value });
        forceUpdate();
    };

    const backClicked = (back, isEdited) => {
        if (isEdited) {
            fetchData("", 'PROF', '');
            setisEdited(isEdited);
        }
        setViewProfessional(back);
        forceUpdate();
    };

    const handleCloseAddUser = () => setAddPro(false);

    function toogleNext_back(e) {
        let page = Page;
        if (e.target.id === 'next') page += 1;
        else page -= 1;
        setPage(page);
    }

    const handlePageChange = (e) => {
        const ID  = e;
        if (ID === 'next' && Pagination.hasMore) {
            fetchData(Pagination.nextCursor, 'PROF', 'lastId');
        } else {
            if (Pagination.currentPage > 1) {
                fetchData(Pagination.prevCursor, 'PROF', 'prevId');
            }
        }
    };

    const openMenu = () => setIsMenuOpen(true);
    const closeMenu = () => setIsMenuOpen(false);

    if (mobile()) return <div></div>;

    return (
        <div className='ProfessionalPage'>
            <div className='ProfessionalPageHeader'>
                <p>Professionals</p>
                <img src={Credipple} alt='Credipple Logo' />
            </div>
            <div className='ProfessionalPageBody'>
                {ViewProfessional ? (
                    <ViewProfessionalPage 
                        backClick={(e, isEdited) => { backClicked(e, isEdited) }} 
                        selectedPro={SelectedUser} 
                        leads={Leads} 
                        pros={Professionals} 
                    />
                ) : (
                    <>
                        <div className='filterAndSearch'>
                            <div className='proListSection'>
                                <p>Professional List</p>
                                {authStore.user.permissions.includes("Client_Create") ? (
                                    <div className='openAddpro' onMouseEnter={openMenu} onMouseLeave={closeMenu}>
                                        {IsMenuOpen && (
                                            <div className='proMenuOpen'>
                                                <div className='AddproConatiner'>
                                                    <img src={AddIcon} alt='Add Client' onClick={handleOpenAddProfessional} />
                                                    <p onClick={handleOpenAddProfessional}>Add Professional</p>
                                                </div>
                                                <hr />
                                            </div>
                                        )}
                                    </div>
                                ) : null}
                            </div>
                          
                            <div className='numofItems' style={{ padding: '5px 10px', borderRadius: '8px'}}>
                                <PaginationControls
                                    currentPage={Pagination.currentPage}
                                    totalPages={Pagination.totalPages}
                                    onPageChange={handlePageChange}
                                    hasMore={Pagination.hasMore}    
                                />
                            </div>
 
                            <div className='filterSearchSect' >
                                <SearchBar
                                    onSearch={(e)=>handleSearchChange(e)}
                                    placeholder='Search'
                                    debounceDelay={1000}
                                    disabled={false}
                                    className=''
                                    searchIconUrl={SearchIcon}
                                    style={{ width: '100%', backgroundColor: 'var(--white, #FFFFFF)' }}
                                />
                            </div>
                        </div>

                        <div className='professionalsList'>
                            {filteredPros.map((item) => (
                                <ProfessionalCard 
                                    key={item._id || item.email} 
                                    handleViewUser={handleViewUser} 
                                    item={item} 
                                />
                            ))}
                        </div>
                    </>
                )}
            </div>

            {/* ADD PRO SECTION */}
            {AddPro && (
                <div className='dashPopUp' style={{ zIndex: '11' }}>
                    <div className='addUserHeaderSection'>
                        <p>Create Professional</p>
                    </div>
                    {Page === 0 ? (
                        <div className='addUserBodySection'>
                            <div className='topInputs'>
                                <TextInput 
                                    className='userInfoFields' 
                                    placeholder='Name & Surname' 
                                    value={FullName} 
                                    label='Name & Surname' 
                                    id='Name' 
                                    onChange={handleUserDetailChange} 
                                />
                                <TextInput 
                                    className='userInfoFields' 
                                    placeholder='Contact Number' 
                                    value={NewUser.phone} 
                                    label='Contact Number' 
                                    id='ContactNumber' 
                                    onChange={handleUserDetailChange} 
                                />
                            </div>
                            <div className='topInputs'>
                                <TextInput 
                                    className='userInfoFields' 
                                    placeholder='Email' 
                                    value={NewUser.email} 
                                    label='Email' 
                                    id='Email' 
                                    onChange={handleUserDetailChange} 
                                />
                                <TextInputDropdown 
                                    className='userInfoFields' 
                                    placeholder='Role' 
                                    label='Role' 
                                    id='Role' 
                                    value={NewUser.professional.services} 
                                    onChange={handleRoleChange}
                                >
                                    <MenuItem value='Design and Illustration'>Design and Illustration</MenuItem>
                                    <MenuItem value='Digital Marketing and Social Media'>Digital Marketing and Social Media</MenuItem>
                                    <MenuItem value='Mobile and Web Development'>Mobile and Web Development</MenuItem>
                                    <MenuItem value='Photography and Videography'>Photography and Videography</MenuItem>
                                    <MenuItem value='Writing and Reporting'>Writing and Reporting</MenuItem>
                                </TextInputDropdown>
                            </div>
                            <div className='topInputs'>
                                <TextInputDropdown 
                                    className='userInfoFields' 
                                    placeholder='Gender' 
                                    value={NewUser.professional.gender} 
                                    label='Gender' 
                                    id='gender' 
                                    onChange={handleGenderChange}
                                >
                                    <MenuItem value='Male'>Male</MenuItem>
                                    <MenuItem value='Female'>Female</MenuItem>
                                    <MenuItem value='Prefer Not To Say'>Prefer Not To Say</MenuItem>
                                </TextInputDropdown>
                                <TextInput 
                                    className='userInfoFields' 
                                    placeholder='Location' 
                                    label='Location' 
                                    id='location' 
                                    value={NewUser.location} 
                                    onChange={handleUserDetailChange} 
                                />
                            </div>
                        </div>
                    ) : (
                        <div className='addUserBodySection'>
                            <div className='topInputs'>
                                <TextInput 
                                    className='userInfoFields' 
                                    placeholder='0,00' 
                                    label='Daily Rate' 
                                    id='dailyRate' 
                                    value={NewUser.professional.ratePerDay} 
                                    onChange={handleUserDetailChange} 
                                />
                                <TextInput 
                                    className='userInfoFields' 
                                    placeholder='Language' 
                                    label='Language' 
                                    id='lang' 
                                    value={NewUser.professional.languages} 
                                    onChange={handleUserDetailChange} 
                                />
                            </div>
                            <div className='topInputs'>
                                <TextInput 
                                    className='userInfoFields' 
                                    value={NewUser.industry} 
                                    placeholder='Industry' 
                                    label='Industry' 
                                    id='industry' 
                                    onChange={handleUserDetailChange} 
                                />
                                <TextInputDropdown 
                                    className='userInfoFields' 
                                    value={NewUser.experienceLevel} 
                                    placeholder='Experience Level' 
                                    label='Experience Level' 
                                    id='exp' 
                                    onChange={handleEXPChange}
                                >
                                    <MenuItem value='Entry Level'>Entry Level</MenuItem>
                                    <MenuItem value='Junior'>Junior</MenuItem>
                                    <MenuItem value='Junior-Intermediate'>Junior-Intermediate</MenuItem>
                                    <MenuItem value='Intermediate'>Intermediate</MenuItem>
                                    <MenuItem value='Intermediate-Senior'>Intermediate-Senior</MenuItem>
                                    <MenuItem value='Senior'>Senior</MenuItem>
                                </TextInputDropdown>
                            </div>
                        </div>
                    )}
                    {Page === 0 ? (
                        <div className='addUserActionSection'>
                            <OutlinedButton id='cancel' className='cancelButton' onClick={handleCloseAddUser}>Cancel</OutlinedButton>
                            <OutlinedButton id='next' className='saveButton' onClick={toogleNext_back}>Next</OutlinedButton>
                        </div>
                    ) : (
                        <div className='addUserActionSection'>
                            <OutlinedButton id='back' className='cancelButton' onClick={toogleNext_back}>Back</OutlinedButton>
                            <OutlinedButton id='save' className='saveButton' onClick={handleSaveUser}>Save</OutlinedButton>
                        </div>
                    )}
                </div>
            )}
        </div>
    )
});

export default Professionals;
